import { Box, BoxProps } from '@amzn/awsui-components-core';
import React from 'react';
import '../../resources/styles/scss/components/common/HorizontalDivider.scss';

interface HorizontalDividerProps {
  readonly margin?: BoxProps.SpacingSize;
}

const HorizontalDivider: React.FC<HorizontalDividerProps> = ({ margin = 'm' }) => (
  <Box margin={{ top: margin, bottom: margin }}>
    <hr className="horizontal-divider" />
  </Box>
);

export default HorizontalDivider;
